import { render, staticRenderFns } from "./TableControlSection.vue?vue&type=template&id=00a20f1a&scoped=true&"
import script from "./TableControlSection.vue?vue&type=script&lang=js&"
export * from "./TableControlSection.vue?vue&type=script&lang=js&"
import style0 from "./TableControlSection.vue?vue&type=style&index=0&id=00a20f1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a20f1a",
  null
  
)

export default component.exports